(function () {
  'use strict';

  angular.module('eclipseApp.boldChat').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('boldChat', {
        url: '/bold-chat',
        parent: 'app',
        title: "boldChat",
        views: {
          content: {
            templateUrl: 'modules/bold-chat/views/bold-chat.html',
            //controller: 'loginCtrl'
          }
        }
      });
  }]);

})();
